import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/stairoids.webp';
import screenshot_target from '../../../images/letterfunnel/thomasberrens.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="Thomas Berrens"
      firstname="Thomas"
      companyname="Stairoids"
      competition="Warmly en Common Room"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/thomasberrens.js